import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../AppContext';
import {
    Typography,
    Button,
    Box,
    Grid,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Snackbar,
    Alert,
    Zoom,
    Fade
} from '@mui/material';
import { RestaurantMenu, LocalDining, EmojiFoodBeverage } from '@mui/icons-material';
import '../../styles/appStyles.css';
import { Link } from 'react-router-dom';

const Home = () => {
    const { orders, code } = useContext(AppContext);
    const { selectedItems } = useContext(AppContext);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleOpenDialog = () => setDialogOpen(true);
    const handleCloseDialog = () => setDialogOpen(false);
    const handleConfirmCall = () => {
        callWaiter();
        handleCloseDialog();
        setSnackbarOpen(true);
    };

    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const callWaiter = async () => {
        try {
            const encodedCode = encodeURIComponent(code);
            const response = await fetch(`${baseUrl}/api/customers/callWaiter?code=${encodedCode}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        } catch (error) {
            alert('Wystąpił błąd podczas wezwania kelnera.');
        }
    };

    // Filtrujemy zamówienia wg statusu
    const newOrders = orders.filter(order => order.status === 'NEW');
    const acceptedOrders = orders.filter(order => order.status === 'ACCEPTED');

    // Obliczamy całkowitą kwotę tylko dla zaakceptowanych zamówień
    const totalAcceptedPrice = acceptedOrders.reduce(
        (sum, order) => sum + order.price * order.quantity,
        0
    );

    return (
        <Box>
            <Zoom in={true} timeout={800}>
                <Paper className="welcome-card" elevation={6}>
                    <Typography 
                        variant="h4" 
                        gutterBottom 
                        sx={{ 
                            fontWeight: 'bold',
                            backgroundImage: 'linear-gradient(45deg, var(--primary-color), var(--secondary-color))',
                            backgroundClip: 'text',
                            textFillColor: 'transparent',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 2
                        }}
                    >
                        <LocalDining sx={{ fontSize: '2rem', mr: 1, verticalAlign: 'text-bottom' }} />
                        Witaj w naszej restauracji!
                    </Typography>
                    <Typography variant="h6" gutterBottom sx={{ color: 'var(--dark-color)', opacity: 0.8, mb: 3 }}>
                        Zamów swoje ulubione dania i napoje lub wezwij kelnera
                    </Typography>
                    <Box mt={3} sx={{ display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, justifyContent: 'center', gap: 2 }}>
                        <Button 
                            component={Link} 
                            to="/menu" 
                            className="action-button primary-button"
                            startIcon={<RestaurantMenu />}
                            sx={{ color: 'white !important', textShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)' }}
                        >
                            Przejdź do menu
                        </Button>
                        <Button 
                            onClick={handleOpenDialog} 
                            className="action-button error-button"
                            startIcon={<EmojiFoodBeverage />}
                            sx={{ color: 'white !important', textShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)' }}
                        >
                            Wezwij kelnera
                        </Button>
                    </Box>
                </Paper>
            </Zoom>

                            <Box mt={3} className="order-section">
                {(acceptedOrders.length === 0 && newOrders.length === 0) ? (
                    <Fade in={true} timeout={1000}>
                        <Typography 
                            variant="h5" 
                            align="center"
                            sx={{
                                py: 4,
                                color: 'var(--dark-color)',
                                opacity: 0.7,
                                fontWeight: 500
                            }}
                        >
                            Brak zamówień. Dodaj coś do koszyka! 🍽️
                        </Typography>
                    </Fade>
                ) : (
                    <>
                        {newOrders.length > 0 && (
                            <Box mb={1}>
                                <Typography className="section-title">⏳ Oczekuje na zatwierdzenie</Typography>
                                <Grid container>
                                    {newOrders.map((order, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={order.id}>
                                            <Zoom in={true} style={{ transitionDelay: `${index * 100}ms` }}>
                                                <Paper
                                                    className="cart-item-card"
                                                    elevation={2}
                                                >
                                                {order.imageUrl && (
                                                    <Box>
                                                        <img
                                                            src={order.imageUrl}
                                                            alt={order.name}
                                                            className="cart-image"
                                                        />
                                                    </Box>
                                                )}
                                                <Box className="cart-item-info">
                                                    <Typography className="cart-item-title">{order.name}</Typography>
                                                    <Typography variant="body2" sx={{ color: 'var(--dark-color)', opacity: 0.7 }}>
                                                        Ilość: <span style={{ fontWeight: 600 }}>{order.quantity}</span>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'var(--dark-color)', opacity: 0.7 }}>
                                                        Cena: <span style={{ fontWeight: 600 }}>{order.price.toFixed(2)} zł</span>
                                                    </Typography>
                                                    <Typography 
                                                        variant="body1" 
                                                        sx={{ 
                                                            color: 'var(--primary-color)', 
                                                            fontWeight: 600,
                                                            mt: 1
                                                        }}>
                                                        Suma: {(order.price * order.quantity).toFixed(2)} zł
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                            </Zoom>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}
                        {acceptedOrders.length > 0 && (
                            <Box>
                                <Typography className="section-title">🍽️ Twoje zamówienie</Typography>
                                <Grid container>
                                    {acceptedOrders.map((order, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={order.id}>
                                            <Zoom in={true} style={{ transitionDelay: `${index * 100}ms` }}>
                                                <Paper
                                                    className="cart-item-card"
                                                    elevation={2}
                                                    sx={{
                                                        borderLeft: '4px solid var(--success-color)'
                                                    }}
                                                >
                                                {order.imageUrl && (
                                                    <Box>
                                                        <img
                                                            src={order.imageUrl}
                                                            alt={order.name}
                                                            className="cart-image"
                                                        />
                                                    </Box>
                                                )}
                                                <Box className="cart-item-info">
                                                    <Typography className="cart-item-title">{order.name}</Typography>
                                                    <Typography variant="body2" sx={{ color: 'var(--dark-color)', opacity: 0.7 }}>
                                                        Ilość: <span style={{ fontWeight: 600 }}>{order.quantity}</span>
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'var(--dark-color)', opacity: 0.7 }}>
                                                        Cena: <span style={{ fontWeight: 600 }}>{order.price.toFixed(2)} zł</span>
                                                    </Typography>
                                                    <Typography 
                                                        variant="body1" 
                                                        sx={{ 
                                                            color: 'var(--success-color)', 
                                                            fontWeight: 600,
                                                            mt: 1
                                                        }}>
                                                        Suma: {(order.price * order.quantity).toFixed(2)} zł
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                            </Zoom>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Paper 
                                    elevation={3} 
                                    sx={{ 
                                        mt: 2,
                                        p: 3, 
                                        borderRadius: '15px',
                                        background: 'linear-gradient(135deg, #fff, #f9f9f9)',
                                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)'
                                    }}
                                >
                                    <Typography 
                                        variant="h5"
                                        sx={{ 
                                            textAlign: 'center',
                                            mb: 2,
                                            color: 'var(--dark-color)',
                                            fontWeight: 700
                                        }}
                                    >
                                        Podsumowanie
                                    </Typography>
                                    <Typography 
                                        variant="h4"
                                        sx={{ 
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color: 'var(--primary-color)',
                                            mb: 3
                                        }}
                                    >
                                        {totalAcceptedPrice.toFixed(2)} zł
                                    </Typography>

                                    {selectedItems.length > 0 && (
                                        <Fade in={true} timeout={1500}>
                                            <Box mt={2} mb={2} sx={{ textAlign: 'center' }}>
                                                <Typography 
                                                    variant="h6" 
                                                    sx={{ 
                                                        mt: 1, 
                                                        mb: 2,
                                                        fontWeight: 500,
                                                        color: 'var(--dark-color)'
                                                    }}
                                                >
                                                    Jeśli jesteś już najedzony 🫢
                                                </Typography>
                                                <Button 
                                                    component={Link} 
                                                    to="/payment" 
                                                    className="action-button primary-button"
                                                    sx={{ px: 4, py: 1.5, fontSize: '1.1rem', color: 'white !important', textShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)' }}
                                                >
                                                    Przejdź do płatności
                                                </Button>
                                            </Box>
                                        </Fade>
                                    )}
                                </Paper>
                            </Box>
                        )}
                    </>
                )}
            </Box>
            <Dialog 
                open={dialogOpen} 
                onClose={handleCloseDialog}
                PaperProps={{ 
                    className: "custom-dialog",
                    sx: { borderRadius: '20px', overflow: 'hidden' }
                }}
            >
                <DialogTitle className="dialog-title">
                    Czy na pewno chcesz wezwać kelnera?
                </DialogTitle>
                <DialogContent className="dialog-content" />
                <DialogActions className="dialog-actions">
                    <Button 
                        onClick={handleCloseDialog}
                        sx={{ 
                            borderRadius: '50px', 
                            px: 3,
                            color: 'var(--dark-color)',
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' } 
                        }}
                    >
                        Anuluj
                    </Button>
                    <Button 
                        onClick={handleConfirmCall} 
                        autoFocus
                        className="action-button primary-button"
                        sx={{ 
                            borderRadius: '50px', 
                            px: 3,
                            color: 'white !important',
                            textShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        Tak
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert 
                    onClose={() => setSnackbarOpen(false)} 
                    severity="success"
                    className="toast-notification"
                    icon={false}
                    sx={{ 
                        background: 'linear-gradient(135deg, var(--success-color), #7bed9f)',
                        color: 'white',
                        fontWeight: 'bold',
                        px: 3,
                        py: 1.5,
                        fontSize: '1rem'
                    }}
                >
                    🔔 Kelner został wezwany!
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Home;